export default function FormGroup(props: { children: React.ReactNode }): JSX.Element {
  return <div className="space-y-6 w-full">{props.children}</div>;
}
